/**
 * AngularJS-compatible response wrapper.
 *
 * The legacy `$http` returned `IHttpResponse<T>` which exposed the body as
 * `response.data`. The 396 consumers of `ApiService` rely on that shape:
 *
 *   apiService.user.login(props).then(r => r.data.payload)
 *
 * Angular's `HttpClient` returns the parsed body directly on success and
 * rejects with an `HttpErrorResponse` whose body is at `.error`. We
 * normalize both paths so callers see `{ data, status }` either way.
 */
import { HttpErrorResponse } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';

export interface AjsResponse<T> {
  data: T;
  status?: number;
}

export async function wrapAjs<T>(observable: Observable<T>): Promise<AjsResponse<T>> {
  try {
    return { data: await firstValueFrom(observable) };
  } catch (err) {
    if (err instanceof HttpErrorResponse) {
      throw { data: err.error as T, status: err.status };
    }
    throw err;
  }
}
